module.exports = __webpack_public_path__ + "img/level3.e62b6856.svg";